// Mount ONCE at the app root. Wires the whole notification pipeline:
//   - Sonner <Toaster> so notification toasts actually render.
//   - useNotificationsAutoToast(): delta-detects new unread notifications on
//     each poll tick and fires a toast + Web Audio sound.
//   - unlockAudio(): browsers block AudioContext until a user gesture, so we
//     prime it on the first pointer/key interaction.
import { useNotificationsAutoToast } from '@/hooks/useNotifications'
import { unlockAudio } from '@/lib/notify'
import { useUIStore } from '@/stores/ui.store'
import { useEffect } from 'react'
import { Toaster } from 'sonner'

export function NotificationsRuntime() {
  const theme = useUIStore((s) => s.theme)
  useNotificationsAutoToast()

  useEffect(() => {
    const prime = () => unlockAudio()
    window.addEventListener('pointerdown', prime, { once: true })
    window.addEventListener('keydown', prime, { once: true })
    return () => {
      window.removeEventListener('pointerdown', prime)
      window.removeEventListener('keydown', prime)
    }
  }, [])

  return (
    <Toaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      expand
      gap={10}
      toastOptions={{ className: 'rounded-xl border border-border shadow-card' }}
    />
  )
}
